module.exports = __webpack_public_path__ + "static/img/home_fn_01.4e17f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_01.png
// module id = iDQc
// module chunks = 34